import { AlertCircle, Check, X } from 'lucide-react'
import type { ReactNode } from 'react'

export function PageTitle({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description?: string; actions?: ReactNode }) {
  return <div className="page-title"><div><div className="eyebrow">{eyebrow ?? 'StoreOps 管理台'}</div><h1>{title}</h1>{description && <p>{description}</p>}</div>{actions && <div className="page-actions">{actions}</div>}</div>
}

export function StatCard({ label, value, hint, icon, tone = 'blue' }: { label: string; value: string; hint: string; icon: ReactNode; tone?: string }) {
  return <article className={`stat-card tone-${tone}`}><div className="stat-top"><span>{label}</span><div className="stat-icon">{icon}</div></div><strong>{value}</strong><div className="stat-hint">{hint}</div></article>
}

export function ApiNotice({ error }: { error: string }) {
  return error ? <div className="api-error"><AlertCircle size={16} />{error}</div> : null
}

export function EmptyState({ children = '暂无数据' }: { children?: ReactNode }) { return <div className="inline-empty">{children}</div> }

export function LoadingRows({ label = '正在从 Java 服务加载...' }: { label?: string }) { return <div className="inline-empty">{label}</div> }

export function ModalFrame({ title, subtitle, children, onClose, footer }: { title: string; subtitle?: string; children: ReactNode; onClose: () => void; footer: ReactNode }) {
  return <div className="modal-backdrop" onMouseDown={event => { if (event.target === event.currentTarget) onClose() }}><div className="modal" role="dialog" aria-modal="true" aria-label={title}><div className="modal-head"><div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div><button className="icon-button" aria-label="关闭" onClick={onClose}><X size={19} /></button></div><div className="modal-body">{children}</div><div className="modal-footer">{footer}</div></div></div>
}

export function Toast({ message }: { message: string }) { return message ? <div className="toast"><Check size={16} />{message}</div> : null }

export function StatusPill({ tone, children }: { tone: string; children: ReactNode }) { return <span className={`status-pill ${tone}`}>{children}</span> }
